<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀</el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="16">
              <el-form-item label-width="0px">
                <el-row>
                  <el-col :span="24">
                    <el-col :span="4">
                      <el-select v-model="form.dtType">
                        <el-option value='' label="전체">전체</el-option>
                        <el-option
                            v-for="item in combos['dtType']"
                            :key="item.value"
                            :value="item.key"
                            :label="item.value">
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="8">
                      <el-date-picker type="date" placeholder="Pick a date" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                    <el-col :span="1" style="text-align: start;">-</el-col>
                    <el-col :span="8">
                      <el-date-picker type="date" placeholder="Pick a date" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="처리결과" label-width="134px">
                <el-col :span="16">
                  <el-select v-model="form.orderStatus">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['orderStatus']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="8">
              <el-form-item label="주문자명" label-width="120px">
                <el-input type="text" v-model="form.custNm" @keyup.native.enter="goOpen" style="width: 65%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="주문번호" label-width="100px">
                <el-input type="text" v-model.trim="form.orderId" @keyup.native.enter="goOpen" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="inner-box">
      <div class="table-area">
        <div class="table-b">
          <div class="table-header">
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="grid"
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  :enableRangeSelection="true"
                  :column-defs="columnDefs"
                  :grid-options="mainGridOptions"
                  :row-data="data"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  :statusBar="statusBar"
                  @grid-ready="onReadyMain"
                  @cell-clicked="onCellClicked" />
            </div>
          </div>
        </div>
      </div>

      <!-- 주문상세내역 그리드 s.-->
      <div class="table-area">
        <div class="table-b">
            <div class="table-header">
                <div class="table-name">
                    <h3 class="ico_table_name">{{ `주문상세내역` }}</h3>
                </div>
                <div class="btn-wrap btn-type1 clearfix">
                    <button class="btn-size btn-gray fl_right" @click="btnDeliverySave" v-if="showDeliverySave">
                      <span class="btn-icon">
                          <i class="fas fa-save"></i>
                      </span>
                      배송확정
                    </button>
                    <button class="btn-size btn-gray fl_right" @click="btnDeliveryCancel" v-if="showDeliveryCancel">
                      <span class="btn-icon">
                          <i class="fas fa-save"></i>
                      </span>
                      배송취소
                    </button>
                    <!--
                    <button class="btn-size btn-gray fl_right" @click="btnPrintAccount" v-if="showPrintAccount">
                      <span class="btn-icon">
                          <i class="fas fa-save"></i>
                      </span>
                      계산서발행
                    </button>
                    -->
                </div>
                
                <div class="grid-tbl-box">
                    <ag-grid-vue 
                        ref="subGrid" 
                        :style="gridStyle"
                        class="ag-theme-alpine"
                        :enableRangeSelection="true"
                        :column-defs="subColumnDefs"
                        :grid-options="subGridOptions"
                        :row-data="subData"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        @grid-ready="onReadySub"
                        />
                </div>

                <div class="grid-tbl-box" v-show="false">
                    <ag-grid-vue 
                        ref="excelGrid" 
                        :style="gridStyle"
                        class="ag-theme-alpine"
                        :enableRangeSelection="true"
                        :column-defs="excelColumnDefs"
                        :grid-options="excelGridOptions"
                        :row-data="excelData"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        @grid-ready="onReadyExcel"
                        />
                </div>
            </div>
        </div>
      </div>
      <!-- 주문상세내역 그리드 e.-->
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal_01 from "@/components/AS/History/Modal/ReceptionModal_01";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
  props: {
  },
  data() {
    return {
      data: [],
      subData: [],
      excelData: [],
      form: {
        companyId : '',
        startDt: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        dtType: '',                // 기간타입
        orderStatus : '',          // 처리결과
        custNm : '',               // 주문자명
        orderId : '',              // 주문번호
        selOrderId: '',            // 선택된 주문번호
        sortType :  '',
        processTime : '',
        deliveryNoCount: 0        // 배송불가 갯수
      },
      combos: {
        'dtType': [],
        'orderStatus' : [],
      },
      startDt: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
      endDt: this.$moment().format('YYYY-MM-DD'),
      accountPrint: [],         // 세금계산서 발행
      showDeliverySave: false, 
      showDeliveryCancel: false,
      showPrintAccount: false,
      curDelivery: '',          // 현재 선택된 ORDER의 배송확정여부

      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 40px; width: 100%;height: 400px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      subGridApi: null,
      subColumnApi: null,
      subGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      excelGridApi: null,
      excelColumnApi: null,
      excelGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,

        excelStyles: [
          {
              id: 'numberType',
              numberFormat: {
                  format: '0',
              },
          },
          {
              id: 'stringType',
              dataType: 'String',
          },
          {
              id: 'dateType',
              dataType: 'DateTime',
          },
        ],
      },
      columnDefs: [],
      subColumnDefs: [],
      excelColumnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init().finally(_ => {
        setTimeout(() => {
          this.goOpen();
        }, 1000)
      });
    },
    onReadySub() {
      this.subGridApi = this.subGridOptions.api;
      this.subColumnApi = this.subGridOptions.columnApi;
    },
    onReadyExcel() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'주문일자', field:'createDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'주문번호', field:'orderId', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'주문자명', field:'custNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'연략처', field:'orderTelNo', width:160},
        {headerName:'수취인명', field:'deliveryNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'수취인휴대전화', field:'deliveryHpNo', width:160},
        {headerName:'배송지', field:'addr', width:310, cellStyle:{textAlign: 'left'}},
        {headerName:'품명', field:'orderItemNm', width:210, cellStyle:{textAlign: 'left'}},
        {headerName:'수량', field:'orderQty', width:120, cellStyle:{textAlign: 'right'}},
        {headerName:'배송일자', field:'deliveryDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'처리결과', field:'orderStatusNm', width:180, cellStyle:{textAlign: 'center'}},
        {headerName:'계산서발행여부', field:'billYnNm', width:130, cellStyle:{textAlign: 'center'}},
        {headerName:'계산서발행여부', field:'billYn', width:130, hide:true},
        {headerName:'메모', field:'memo', width:300, cellStyle:{textAlign: 'left'}}
      ];
    },
    createSubColumnDefs() {
      const vm = this;
      this.subColumnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'주문일자', field:'createDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'주문번호', field:'orderId', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'품번', field:'itemCd', width:200, cellStyle:{textAlign: 'center'}},
        {headerName:'품명', field:'itemNm', width:360},
        {headerName:'주문수량', field:'qty', width:110, cellStyle:{textAlign: 'right'}},
        {headerName:'재고수량', field:'goodQty', width:110, cellStyle:{textAlign: 'right'}},
        {headerName:'배송가능여부', field:'ltlDeliveryOK', width:180, 
          cellStyle:(params) => { 
                        if(params.value==='배송불가'){
                            return {textAlign: 'center', color: 'red'}
                        }else{
                            return {textAlign: 'center', color: 'blue'}
                        }
                    }
        }
      ];
    },
    createExcelColumnDefs() {
      const vm = this;
      this.excelColumnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'주문일자', field:'createDt', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'주문번호', field:'orderId', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'주문자명', field:'custNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'연락처', field:'orderTelNo', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'수취인명', field:'deliveryNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'수취인휴대전화', field:'deliveryHpNo', width:160},
        {headerName:'배송지', field:'addr', width:300, cellStyle:{textAlign: 'left'}},
        {headerName:'품번', field:'itemCd', width:310, cellStyle:{textAlign: 'left'}, cellClass: 'stringType'},
        {headerName:'품명', field:'itemNm', width:310, cellStyle:{textAlign: 'left'}},
        {headerName:'수량', field:'qty', width:100, cellStyle:{textAlign: 'right'}},
        {headerName:'배송일자', field:'deliveryDt', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'처리결과', field:'orderStatusNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'계산서발행여부', field:'billYnNm', width:130, cellStyle:{textAlign: 'center'}},
        {headerName:'메모', field:'memo', width:300, cellStyle:{textAlign: 'left'}}
      ];
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      this.goDetail(params.data)
    },
    /**
     * 접수/처리 상세 팝업 오픈
     */
    openModel(param) {
      console.log(param);
      let vm = this;
      this.$modal.open({
        width: 800,
        component: ReceptionModal_01,
        parent: this,
        props: {
          data: {
            asId: param.asId,
            custId: param.custId,
            sortType: '',
            popHeadInfo: '', //this.custParam.popHeadInfo,
            //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
            recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
            procsDt: this.$moment(param.procDt).format('YYYY-MM-DD')
          }
        },
        events: {
          close(data) {
            console.log('close', data);
          },
        }
      });
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    isAuth(){
      const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===121)
      let GrantSelect = false // 조회권한
      if(auth && auth.length > 0){
        GrantSelect = auth[0].grantSelect === 'Y' ? true : false   
      }

      if(!GrantSelect){
        this.$swal({ type: 'warning', text: '조회권한이 없습니다.' });
        return false;
      }

      return true;
    },
    goOpen() {
      let vm = this
      console.log('goOpen passed ')
      let vStartDt = this.form.startDt ? this.form.startDt.replace(/[^0-9]/g, '') : '';
      let vEndDt = this.form.endDt ? this.form.endDt.replace(/[^0-9]/g, '') : '';
      if(this.form.dtType === ''){
        vStartDt = '';
        vEndDt = '';
      } 

      if(!this.isAuth()){
        return false;
      }
      
      if(Number(vStartDt) > Number(vEndDt)){
        this.$swal({ type: 'warning', text: '검색 일자를 정확히 입력해주세요.' });
        return false;
      }

      this.$store.commit('loading')

      const vform = {
        ...this.form,
        startDt : vStartDt,
        endDt : vEndDt,
        payBank: '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime : ''
      }

      this.form.deliveryNoCount = 0; //초기화
      this.$http.post(_url("/api/asMng/deliveryList/list"), vform).then(response => {
        console.log('response.data' , response.data)
        this.data = response.data.map(x=>{
          x.orderTelNo = _phone(x.orderTelNo);
          x.billYnNm = x.billYn === 'N' ? '무' : '유';
          x.addr = x.addr1 + ' ' + x.addr2;
          x.createDt = x.createDt && x.createDt.length >=10 ? x.createDt.substring(0,10) : '';  
          x.deliveryDt = x.deliveryDt && x.deliveryDt.length >=10 ? x.deliveryDt.substring(0,10) : '';
          
          const vobj = vm.combos['orderStatus'].filter(y=>y.key===x.orderStatus);
          if(vobj && vobj.length > 0){
            x.orderStatusNm = vobj[0].value;
          }
          
          return x;
        })

        if(response.data && response.data.length > 0){
          vm.goDetail({orderId: response.data[0].orderId});
        }

      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    goDetail(param) {
      // 주문상세내역 조회
      let vm = this
      
      if(!this.isAuth()){
        return false;
      }
      
      this.$store.commit('loading')

      const vform = {
        orderId : param.orderId,
        sortType : ''
      }

      this.form.selOrderId = param.orderId || '';
      this.form.deliveryNoCount = 0; // 초기화
      this.curDelivery = '';  // 초기화
      this.$http.post(_url("/api/asMng/deliveryList/selectItem"), vform).then(response => {
        console.log('subData data : ' , response.data)
        // 세금계산서 발행용
        this.accountPrint = response.data.accountPrint;

        this.subData = response.data.selectItemList.map((x, index)=>{
          console.log('x qty: ', x.qty, x.goodQty);
          const vQty = x.qty && x.qty!='' ? Number(x.qty) : 0;
          const vGoodQty = x.goodQty && x.goodQty!='' ? Number(x.goodQty) : 0;

          if(vQty > vGoodQty){
            x.ltlDeliveryOK = '배송불가';
            vm.form.deliveryNoCount = Number(vm.form.deliveryNoCount) + 1;
          } else {
            x.ltlDeliveryOK = '배송가능';
          }

          if(!(x.deliveryDt === '' || x.deliveryDt === null)){
            x.ltlDeliveryOK = '배송완료';
            this.curDelivery = 'END'; 
          }
          
          x.createDt = x.createDt && x.createDt.length >=10 ? x.createDt.substring(0,10) : '';  

          if(index === 0){
            const vPObj = vm.accountPrint;
            const vOrderStatus = vPObj && vPObj.length>0? vPObj[0].orderStatus : '';
            const vBillYn = vPObj && vPObj.length>0? vPObj[0].billYn : '';

            // console.log('vm.form.deliveryNoCount,  x.orderStatus: ', vm.form.deliveryNoCount, vOrderStatus, vBillYn )
            if(vm.form.deliveryNoCount === 0 && vOrderStatus=== 'PayY' ){
              vm.showDeliverySave = true;
              vm.showPrintAccount = false;
              vm.showDeliveryCancel = false;

            } else if(vOrderStatus === 'DeliveryY' ){
              vm.showDeliveryCancel = true;
              vm.showDeliverySave = false;

              if(vBillYn === 'Y')
                vm.showPrintAccount = true;
              else
                vm.showPrintAccount = false;
            } else {
              vm.showDeliveryCancel = false;
              vm.showPrintAccount = false;
              vm.showDeliverySave = false;
            }
 
          } 

          return x;
        })
        
        


      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    btnDeliverySave(){
      // 배송확정

      if(!this.isAuth()){
        return false;
      }

      if(this.form.selOrderId === '' || this.form.selOrderId === '0'){
        this.$swal({ type: 'warning', text: '배송내역을 선택하세요.' });
        return false;
      }

      if(this.form.deliveryNoCount > 0){
        this.$swal({ type: 'warning', text: '배송불가 항목이 존재합니다.' });
        return false;
      }

      if(this.curDelivery === 'END'){
        this.$swal({ type: 'warning', text: '이미 배송확정상태입니다.' });
        return false;
      }

      this.$swal({
          type: 'warning',
          text: `배송 확정을 하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
      }).then((result) => {
          if (result.value) {
              const vform0 = {
                  orderId: this.form.selOrderId
              }
              const vform = JSON.parse(JSON.stringify(vform0))
              
              this.$store.commit('loading')
              this.$http.put(_url("/api/asMng/deliveryList/updateDelivery"), vform)
                  .then(response => {
                      this.goOpen();
                      this.$swal({ type: 'success', text: '배송 확정을 하였습니다.' });
                      //this.goDetail(vform0);
              
                  }).catch((e) => {
                      // console.error(e);
                      // this.$swal({ type: 'success', text: '배송 확정을 실패 하였습니다.' })
                  })
                  .finally(() => {
                      this.$store.commit('finish')
                  });
          }
      });
    },
    btnDeliveryCancel(){
      // 배송취소

      if(!this.isAuth()){
        return false;
      }

      if(this.form.selOrderId === '' || this.form.selOrderId === '0'){
        this.$swal({ type: 'warning', text: '배송내역을 선택하세요.' });
        return false;
      }

      this.$swal({
          type: 'warning',
          text: `배송 취소를 하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
      }).then((result) => {
          if (result.value) {
              const vform0 = {
                  orderId: this.form.selOrderId
              }
              const vform = JSON.parse(JSON.stringify(vform0))
              
              this.$store.commit('loading')
              this.$http.put(_url("/api/asMng/deliveryList/updateDeliveryCancel"), vform)
                  .then(response => {
                      this.$swal({ type: 'success', text: '배송 취소를 하였습니다.' });

                      this.goDetail(vform0);
                  }).catch((e) => {
                      // console.error(e);
                      // this.$swal({ type: 'success', text: '배송 취소를 실패 하였습니다.' })
                  })
                  .finally(() => {
                      this.$store.commit('finish')
                  });
          }
      });
    },

    btnPrintAccount(){
      // 계산서발행

      if(!this.isAuth()){
        return false;
      }

      if(this.form.selOrderId === '' || this.form.selOrderId === '0'){
        this.$swal({ type: 'warning', text: '배송내역을 선택하세요.' });
        return false;
      }

      this.$swal({
          type: 'warning',
          text: `계산서를 발행 하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
      }).then((result) => {
          if (result.value) {
              
              // 상세조회시 세금계산서 데이타 가져온 상태
              // TODO : 출력을 어떻게 할지 정해지면 추후 처리필요
              this.accountPrint;

              this.$swal({ type: 'success', text: 'TODO: 계산서를 발행하였습니다.' });

          }
      });
    },
    excelDown(){
      this.$store.commit('loading')

      let vStartDt = this.form.startDt ? this.form.startDt.replace(/[^0-9]/g, '') : '';
      let vEndDt = this.form.endDt ? this.form.endDt.replace(/[^0-9]/g, '') : '';

      const vform = {
        ...this.form,
        startDt : vStartDt,
        endDt : vEndDt,
        payBank: '',
      }

      console.log('excelDown pass vform: ', vform);
      this.form.deliveryNoCount = 0; //초기화
      this.$http.post(_url("/api/asMng/deliveryList/selectExcelItem"), vform).then(response => {
        console.log('excelDown response.data' , response.data)
        this.excelData = response.data.map((x, index)=>{
          x.no = index + 1;
          x.addr = x.addr1 + ' ' + x.addr2;
          x.createDt = x.createDt && x.createDt.length>=10 ? x.createDt.substring(0,10) : '';
          x.deliveryDt = x.deliveryDt && x.deliveryDt.length>=10 ? x.deliveryDt.substring(0,10) : '';
          x.orderTelNo = _phone(x.orderTelNo) || '';
          x.deliveryHpNo = _phone(x.deliveryHpNo) || '';
          x.itemCd = x.itemCd.toString()+'';
          x.billYnNm = x.billYn === 'N' ? '무' : '유';
          
          const vobj = this.combos['orderStatus'].filter(y=>y.key===x.orderStatus);
          if(vobj && vobj.length > 0){
            x.orderStatusNm = vobj[0].value;
          }
          
          return x;
        }); 

      }).finally(() => {
        this.$store.commit('finish');

        var params = {
          fileName : "배송처리리스트"
        };
        this.excelGridOptions.api.exportDataAsExcel(params);

      });
      
    },
    async init() {
      this.$store.commit('loading');
      
      // 기간타입 : DateType   
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 261}})
                    .then(response => {
                      this.combos['dtType'] = 
                        response.data
                          .filter(x=>x.key==='Call_DT' || x.key==='Delivery_DT')
                          .map(y=>{
                            if(y.key==='Call_DT'){
                              y.value = '주문일자'
                            }
                            return y;
                          })
                         || [];

                         this.form.dtType = 'Call_DT';
                    });

      // 처리결과 : OrderStatus
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 265}})
                    .then(response => {
                      this.combos['orderStatus'] = 
                        response.data
                          .filter(x=>x.key!=='PayN' && x.key!=='OrderCancel')
                          .map(y=>{
                            if(y.key==='PayY'){
                              y.value = '미배송'
                            }
                            return y;
                          })
                         || []
                    });

      this.createMainColumnDefs();
      this.createSubColumnDefs(); // 주문상세내역
      this.createExcelColumnDefs();

      this.$store.commit('finish')

    },
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    console.log('search', this.search);
    this.form.companyId = this.$store.state.loginInfo.compCd;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>